import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h6 mb-0 py-03"
}
const _hoisted_2 = ["innerHTML"]

import { ref, onMounted } from 'vue';


export default {
  __name: 'alert',
  props: {
	title:      {type: String, default: null},
	message:    {type: String, required: true},
	type:       {type: String, default: 'notice'},
	timeout:    {type: Number, default: null},
},
  setup(__props) {

const props = __props;

const show = ref(true);

onMounted(() => {
	if (props.timeout) {
		setTimeout(() => {
			show.value = false;
		}, props.timeout);
	}
})

function close() {
	show.value = false;
}


return (_ctx, _cache) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        role: "alert",
        class: _normalizeClass('alert alert-' + __props.type + ' d-inline-block')
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "close",
          onClick: close
        }, "×"),
        (__props.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", { innerHTML: __props.message }, null, 8 /* PROPS */, _hoisted_2)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

}